import { j as G } from "./jsx-runtime-3tyXYecC.mjs";
import * as P from "react";
import { forwardRef as T, Children as O, isValidElement as E, cloneElement as W } from "react";
import { f as d } from "./index-LyFokDcn.mjs";
import { b as H, c as n, m as L } from "./tss-DN0acMKN.mjs";
import { c as j } from "./index-DkZ16bcJ.mjs";
import { g as V, c as N } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as U } from "./memoTheme-BzXKG_-k.mjs";
import { c as k } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as D } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { B as A, a as q } from "./widths.styles-CkAQdON2.mjs";
import { s as I, u as J, c as K } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { B as Q } from "./button-CUHBhgeQ.mjs";
function X(o) {
  return P.Children.toArray(o).filter((r) => /* @__PURE__ */ P.isValidElement(r));
}
function Y(o) {
  return V("MuiButtonGroup", o);
}
const t = D("MuiButtonGroup", ["root", "contained", "outlined", "text", "disableElevation", "disabled", "firstButton", "fullWidth", "horizontal", "vertical", "colorPrimary", "colorSecondary", "grouped", "groupedHorizontal", "groupedVertical", "groupedText", "groupedTextHorizontal", "groupedTextVertical", "groupedTextPrimary", "groupedTextSecondary", "groupedOutlined", "groupedOutlinedHorizontal", "groupedOutlinedVertical", "groupedOutlinedPrimary", "groupedOutlinedSecondary", "groupedContained", "groupedContainedHorizontal", "groupedContainedVertical", "groupedContainedPrimary", "groupedContainedSecondary", "lastButton", "middleButton"]), Z = (o, r) => {
  const {
    ownerState: e
  } = o;
  return [{
    [`& .${t.grouped}`]: r.grouped
  }, {
    [`& .${t.grouped}`]: r[`grouped${n(e.orientation)}`]
  }, {
    [`& .${t.grouped}`]: r[`grouped${n(e.variant)}`]
  }, {
    [`& .${t.grouped}`]: r[`grouped${n(e.variant)}${n(e.orientation)}`]
  }, {
    [`& .${t.grouped}`]: r[`grouped${n(e.variant)}${n(e.color)}`]
  }, {
    [`& .${t.firstButton}`]: r.firstButton
  }, {
    [`& .${t.lastButton}`]: r.lastButton
  }, {
    [`& .${t.middleButton}`]: r.middleButton
  }, r.root, r[e.variant], e.disableElevation === !0 && r.disableElevation, e.fullWidth && r.fullWidth, e.orientation === "vertical" && r.vertical];
}, _ = (o) => {
  const {
    classes: r,
    color: e,
    disabled: p,
    disableElevation: l,
    fullWidth: m,
    orientation: s,
    variant: u
  } = o, f = {
    root: ["root", u, s, m && "fullWidth", l && "disableElevation", `color${n(e)}`],
    grouped: ["grouped", `grouped${n(s)}`, `grouped${n(u)}`, `grouped${n(u)}${n(s)}`, `grouped${n(u)}${n(e)}`, p && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return K(f, Y, r);
}, oo = I("div", {
  name: "MuiButtonGroup",
  slot: "Root",
  overridesResolver: Z
})(U(({
  theme: o
}) => ({
  display: "inline-flex",
  borderRadius: (o.vars || o).shape.borderRadius,
  variants: [{
    props: {
      variant: "contained"
    },
    style: {
      boxShadow: (o.vars || o).shadows[2]
    }
  }, {
    props: {
      disableElevation: !0
    },
    style: {
      boxShadow: "none"
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${t.lastButton},& .${t.middleButton}`]: {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${t.lastButton},& .${t.middleButton}`]: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "horizontal"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderRight: o.vars ? `1px solid rgba(${o.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${o.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${t.disabled}`]: {
          borderRight: `1px solid ${(o.vars || o).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "text",
      orientation: "vertical"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderBottom: o.vars ? `1px solid rgba(${o.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${o.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
        [`&.${t.disabled}`]: {
          borderBottom: `1px solid ${(o.vars || o).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(o.palette).filter(k()).flatMap(([r]) => [{
    props: {
      variant: "text",
      color: r
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderColor: o.vars ? `rgba(${o.vars.palette[r].mainChannel} / 0.5)` : H(o.palette[r].main, 0.5)
      }
    }
  }]), {
    props: {
      variant: "outlined",
      orientation: "horizontal"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderRightColor: "transparent",
        "&:hover": {
          borderRightColor: "currentColor"
        }
      },
      [`& .${t.lastButton},& .${t.middleButton}`]: {
        marginLeft: -1
      }
    }
  }, {
    props: {
      variant: "outlined",
      orientation: "vertical"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderBottomColor: "transparent",
        "&:hover": {
          borderBottomColor: "currentColor"
        }
      },
      [`& .${t.lastButton},& .${t.middleButton}`]: {
        marginTop: -1
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "horizontal"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderRight: `1px solid ${(o.vars || o).palette.grey[400]}`,
        [`&.${t.disabled}`]: {
          borderRight: `1px solid ${(o.vars || o).palette.action.disabled}`
        }
      }
    }
  }, {
    props: {
      variant: "contained",
      orientation: "vertical"
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderBottom: `1px solid ${(o.vars || o).palette.grey[400]}`,
        [`&.${t.disabled}`]: {
          borderBottom: `1px solid ${(o.vars || o).palette.action.disabled}`
        }
      }
    }
  }, ...Object.entries(o.palette).filter(k(["dark"])).map(([r]) => ({
    props: {
      variant: "contained",
      color: r
    },
    style: {
      [`& .${t.firstButton},& .${t.middleButton}`]: {
        borderColor: (o.vars || o).palette[r].dark
      }
    }
  }))],
  [`& .${t.grouped}`]: {
    minWidth: 40,
    boxShadow: "none",
    props: {
      variant: "contained"
    },
    style: {
      "&:hover": {
        boxShadow: "none"
      }
    }
  }
}))), to = /* @__PURE__ */ P.forwardRef(function(r, e) {
  const p = J({
    props: r,
    name: "MuiButtonGroup"
  }), {
    children: l,
    className: m,
    color: s = "primary",
    component: u = "div",
    disabled: f = !1,
    disableElevation: v = !1,
    disableFocusRipple: g = !1,
    disableRipple: $ = !1,
    fullWidth: h = !1,
    orientation: w = "horizontal",
    size: C = "medium",
    variant: i = "outlined",
    ...x
  } = p, a = {
    ...p,
    color: s,
    component: u,
    disabled: f,
    disableElevation: v,
    disableFocusRipple: g,
    disableRipple: $,
    fullWidth: h,
    orientation: w,
    size: C,
    variant: i
  }, c = _(a), S = P.useMemo(() => ({
    className: c.grouped,
    color: s,
    disabled: f,
    disableElevation: v,
    disableFocusRipple: g,
    disableRipple: $,
    fullWidth: h,
    size: C,
    variant: i
  }), [s, f, v, g, $, h, C, i, c.grouped]), R = X(l), M = R.length, z = (b) => {
    const B = b === 0, y = b === M - 1;
    return B && y ? "" : B ? c.firstButton : y ? c.lastButton : c.middleButton;
  };
  return /* @__PURE__ */ G.jsx(oo, {
    as: u,
    role: "group",
    className: N(c.root, m),
    ref: e,
    ownerState: a,
    ...x,
    children: /* @__PURE__ */ G.jsx(A.Provider, {
      value: S,
      children: R.map((b, B) => /* @__PURE__ */ G.jsx(q.Provider, {
        value: z(B),
        children: b
      }, B))
    })
  });
}), ro = L({ name: "ButtonGroup" })(({ constructs: o, palette: r, mixins: e }) => {
  var p, l;
  return {
    root: {
      borderRadius: "2px",
      "& .MuiButtonGroup-grouped:hover": {
        boxShadow: d.ifFeature(
          "encore",
          `1px 1px 0px 2px ${e.alpha(o.surface.neutral.xxStrong, 0.03)}`,
          "0 2px 2px 0 rgba(0, 0, 0, 0.1)"
        )
      }
    },
    grouped: {
      minWidth: "0"
    },
    groupedHorizontal: {
      "&:not(:first-child) .MuiButton-root": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      "&:not(:last-child) .MuiButton-root": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      "&&.Mui-disabled": {
        "&:not(:first-child), &:not(:first-child) .MuiButton-root": {
          marginLeft: d.ifFeature("encore", "0", "-1px"),
          "$altStyling &": {
            borderLeftColor: "transparent"
          }
        },
        "&&": d.ifFeature("encore", {
          borderColor: "transparent",
          marginRight: "1px"
        })
      }
    },
    groupedContainedSecondary: d.ifFeature(
      "encore",
      {
        "&&:not(.Mui-disabled):not(:last-child), &:not(.Mui-disabled):not(:last-child) MuiButton-root .MuiButton-grouped": {
          borderRightWidth: "1px",
          marginRight: "-1px"
        }
      },
      {}
    ),
    groupedOutlined: d.ifFeature(
      "encore",
      {
        "&&:not(.Mui-disabled):not(:last-child)": {
          borderRightWidth: "1px"
        }
      },
      {}
    ),
    groupedContainedHorizontal: {
      "&:not(.Mui-disabled):not(:last-child), &:not(.Mui-disabled):not(:last-child) .MuiButton-root": {
        marginRight: "1px",
        /* @startCleanup encore */
        border: d.ifFeature("encore", void 0, "none")
        /* @endCleanup encore */
      }
    },
    altStyling: {
      "& .Mui-disabled.MuiButtonGroup-grouped": {
        "&, &:not(:last-child)": {
          borderRightColor: (p = e.alpha) == null ? void 0 : p.call(e, r.background.default, 0.5)
        }
      },
      "& .MuiButtonGroup-grouped:hover": {
        boxShadow: d.ifFeature("encore", `1px 1px 0 1px ${(l = e.alpha) == null ? void 0 : l.call(e, o.surface.neutral.weak, 0.2)}`)
      }
    }
  };
}), bo = T((o, r) => {
  const {
    ButtonProps: e,
    children: p,
    color: l = "secondary",
    classes: m,
    dark: s,
    disabled: u,
    processing: f,
    size: v,
    toggle: g,
    variant: $ = "contained",
    ...h
  } = o, w = g ? "secondary" : l, { classes: C } = ro(void 0, { props: { classesProp: m } }), i = {
    ...C,
    ...m
  };
  return /* @__PURE__ */ G.jsx(
    to,
    {
      classes: {
        root: j(i.root, {
          [i.altStyling]: s
        }),
        grouped: i.grouped,
        groupedHorizontal: i.groupedHorizontal,
        groupedContainedHorizontal: i.groupedContainedHorizontal,
        groupedContained: i.groupedContained,
        groupedContainedPrimary: i.groupedContainedPrimary,
        groupedContainedSecondary: i.groupedContainedSecondary,
        groupedOutlinedPrimary: i.groupedOutlined,
        groupedOutlinedSecondary: i.groupedOutlined
      },
      color: l,
      disabled: u,
      ref: r,
      role: d.ifFeature("encore", g === "single" ? "radiogroup" : "group", "group"),
      variant: $,
      ...h,
      "data-fabric-component": "ButtonGroup",
      children: O.map(p, (x) => {
        var c, S, R, M, z, b, B, y, F;
        if (!E(x))
          return null;
        const a = x;
        return a.type === Q ? W(a, {
          ...e,
          "aria-checked": d.ifFeature(
            "encore",
            g ? (c = a.props) == null ? void 0 : c.toggled : (S = a.props) == null ? void 0 : S["aria-checked"],
            (R = a.props) == null ? void 0 : R["aria-checked"]
          ),
          color: d.ifFeature("encore", (M = a.props) != null && M.toggled ? "primary" : w, l),
          dark: a.props.dark || s,
          disabled: a.props.disabled || u,
          processing: ((z = a.props) == null ? void 0 : z.processing) || f,
          role: d.ifFeature("encore", g === "single" ? "radio" : (b = a.props) == null ? void 0 : b.role, (B = a.props) == null ? void 0 : B.role),
          size: ((y = a.props) == null ? void 0 : y.size) || v,
          variant: ((F = a.props) == null ? void 0 : F.variant) || $
        }) : x;
      })
    }
  );
});
export {
  bo as B
};
//# sourceMappingURL=button-group-esTF0Zix.mjs.map
